var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 14.5,
    r: 13.5,
    stroke: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.255 20.964h0-.008a3.679 3.679 0 01-1.854-.55l-.003-.003a3.197 3.197 0 01-1.52-2.38v-.002c-.083-.701-.122-1.406-.119-2.112v-.004c-.006-1.513.01-3.027.048-4.54h0v-.01a3.7 3.7 0 01.647-2.096 3.284 3.284 0 012.371-1.394h.006c.783-.09 1.571-.13 2.36-.122v0h.004c1.514 0 3.027.014 4.535.063h.007a3.61 3.61 0 012.068.692h0a3.307 3.307 0 011.354 2.432h0l.001.01c.066.654.089 1.316.093 1.982.01 1.354.01 2.718-.027 4.07h0v.005a6.202 6.202 0 01-.209 1.504c-.353 1.242-1.18 2.003-2.447 2.332-.591.152-1.202.165-1.865.179l-.125.002c-.46.01-.898.007-1.34.004a88.064 88.064 0 00-.675-.004h-.437l.002.02c-.18-.003-.362-.007-.542-.012-.777-.017-1.55-.035-2.325-.066z",
    stroke: "#fff",
    strokeWidth: 0.794
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.172 14.43a3.67 3.67 0 01-3.764 3.584c-1.997-.036-3.627-1.704-3.591-3.677a3.683 3.683 0 013.743-3.57c1.995.023 3.646 1.7 3.612 3.662zm-1.297-.025c0-1.319-1.075-2.371-2.455-2.343a2.317 2.317 0 00-2.304 2.308 2.38 2.38 0 004.76.035zM18.315 11.48a.832.832 0 01-.851-.842.85.85 0 01.85-.846.845.845 0 110 1.688z",
    fill: "#fff"
  })));
}
export default SvgInstagram;